import { render, staticRenderFns } from "./BulkUpdateDueDateDrawer.vue?vue&type=template&id=20e19f95"
import script from "./BulkUpdateDueDateDrawer.vue?vue&type=script&lang=js"
export * from "./BulkUpdateDueDateDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports